
//https://www.npmjs.com/package/idb-keyval
var idbKeyval=function(e){"use strict";class t{constructor(e="keyval-store",t="keyval"){this.storeName=t,this._dbp=new Promise((r,n)=>{const o=indexedDB.open(e,1);o.onerror=(()=>n(o.error)),o.onsuccess=(()=>r(o.result)),o.onupgradeneeded=(()=>{o.result.createObjectStore(t)})})}_withIDBStore(e,t){return this._dbp.then(r=>new Promise((n,o)=>{const s=r.transaction(this.storeName,e);s.oncomplete=(()=>n()),s.onabort=s.onerror=(()=>o(s.error)),t(s.objectStore(this.storeName))}))}}let r;function n(){return r||(r=new t),r}return e.Store=t,e.get=function(e,t=n()){let r;return t._withIDBStore("readonly",t=>{r=t.get(e)}).then(()=>r.result)},e.set=function(e,t,r=n()){return r._withIDBStore("readwrite",r=>{r.put(t,e)})},e.del=function(e,t=n()){return t._withIDBStore("readwrite",t=>{t.delete(e)})},e.clear=function(e=n()){return e._withIDBStore("readwrite",e=>{e.clear()})},e.keys=function(e=n()){const t=[];return e._withIDBStore("readonly",e=>{(e.openKeyCursor||e.openCursor).call(e).onsuccess=function(){this.result&&(t.push(this.result.key),this.result.continue())}}).then(()=>t)},e}({});

console.log('SERVICE WORKER - LOADED');
const CACHE_NAME = 'lospec-2';
//the offline page carries its own css and images (projects/down-page/node/build-down-page.js)
const FILES_TO_CACHE = [
  '/offline.htm',
  '/favicon.ico',
];
const USER_SESSION_EXPIRATION = 60; //minutes

//add cached pages
self.addEventListener('install', function(e) {
	console.log('SERVICE WORKER - INSTALLED ');
	e.waitUntil(
	    caches.open(CACHE_NAME).then((cache) => {
	      console.log('[ServiceWorker] Pre-caching offline page',FILES_TO_CACHE);
	      return cache.addAll(FILES_TO_CACHE);
	    })
	);
});


var notificationsBroadcast = new BroadcastChannel('notifications');

//wait for push event
self.addEventListener('push', e=> {
	var data = e.data.json();

	console.log('push received',data);

	//console.log('cookies please',document.cookie);

	//get currently stored session id
	verifySessionUser().then(sessionUserId => {
		if (!sessionUserId) console.log('sessionUserId not found (somehow....)');
		console.log('sessionUserId - stored:',sessionUserId,'| push:',data.data.userId,'| =',sessionUserId==data.data.userId);

		//if id passed from push matches stored ID
		if (sessionUserId != data.data.userId) return console.log('stored session ID does not match push id, not displaying push');

		//show push notifiation to user
		self.registration.showNotification(data.title, {
			body: data.body,
			icon: data.image?data.image : '/images/favicons/favicon64.png',
			badge: '/images/badge.png',
			data: data.data,
		});

		//broadcast new notification info to all open pages
		notificationsBroadcast.postMessage({unseenNotifications: data.unseenNotifications});
	});
});

//user clicked / tapped a push notification
self.addEventListener('notificationclick', function(event) {
	const clickedNotification = event.notification;
	clickedNotification.close();

	//exit if the url could not be found
	if (!event.notification.data || !event.notification.data.url) return;

	//get url from event
	var url = event.notification.data.url;
	//if the url contains a #, remove it and everything after it
	var cleanedUrl = url.indexOf('#') !== -1 ? url.substring(0, url.indexOf('#')) :url;

	var urlAnchor = url.substring(url.indexOf('#'), url.length);

    event.waitUntil(
        self.clients.matchAll({type: 'window', includeUncontrolled: true}).then( windowClients => {
			console.log('opening window', windowClients.length, 'windows')
            // Check if there is already a window/tab open with the target URL
            for (var i = 0; i < windowClients.length; i++) {
                var client = windowClients[i];

                //if the page url contains a #, remove it and everything after it
                var cleanedClientUrl;
                if (client.url.indexOf('#') !== -1)
                	cleanedClientUrl = client.url.substring(0, client.url.indexOf('#'));
                else cleanedClientUrl = client.url;

                // if the cleaned URLs match
                if (cleanedClientUrl === cleanedUrl && 'focus' in client) {
					//focus and reload the window that has this page open
                    client.focus();

                    //if the url had a # in it, first navigate to the cleaned url (otherwise it wont refresh)
					if (url.indexOf('#')) {
						console.log('url has #, attempting double nav');
						return client.navigate(cleanedUrl)
							.then(function (newClient) {
								console.log('first load done',newClient.visibilityState,newClient);

								newClient.postMessage({jumpToAnchor: urlAnchor});

							});
					}
					//no #, navigate normally
					else {
						return client.navigate(url);
					}

                    return;
                }
            }
            // If not, then open the target URL in a new window/tab.
            if (self.clients.openWindow) {
                return self.clients.openWindow(url);
            }
        })
    );
});

//returns the offline page (first file in cached files list)
function offlinePage () {
	return caches.open(CACHE_NAME).then((cache) => cache.match(FILES_TO_CACHE[0]));
}

//catched failed requests and displays the offline page when necessary
self.addEventListener('fetch', function(e) {
	// /console.log('SERVICE WORKER - FETCH',e.request.url,e);

	e.respondWith(
		//attempt to request page from server
		fetch(e.request)
			//an error page the app didn't send (nginx's 502 or 404 when the app is down or unreachable) means the
			//site is down too. the app marks its own responses with X-Lospec, so its own 404 and 500 pages still show.
			//redirects arrive as opaque responses with status 0, so only basic responses are checked
			.then((response) => {
				if (e.request.mode == 'navigate' && response.type == 'basic' && !response.ok && !response.headers.has('X-Lospec'))
					return offlinePage().then((page) => page || response);
				return response;
			})
			//request failed - no connection
			.catch(() => {
				//if this was a navigation event (you requested a full page)
				if (e.request.mode  == 'navigate')
					return offlinePage();
				//for all other types of requests, attempt to return a cached version of the file (eg for the other files needed for the offline page)
				else
	        		return caches.open(CACHE_NAME).then((cache) => cache.match(e.request));
	        })

	        //request was successful
	        .then((response) => {

				//check if the logout url was requested
				if (e.request.url.includes('lospec.com/user/logout')) {
					console.log('SW - user logged out, clearing saved session user');
					idbKeyval.del('currentUserSession');
				}

				//check if the url was a login auth url (the user just logged in)
				else if (/^.*lospec\.com\/user\/login\/.*\/auth/.test(e.request.url)) {
					console.log('SW - user logged in, updating session user');
					verifySessionUser();
				}

				return response;
	        })
	);
});

//refreshes cache when cache name changes
self.addEventListener('activate', function(e) {
	console.log('SERVICE WORKED - ACTIVATED ');

	verifySessionUser();

	e.waitUntil(
	    caches.keys().then((keyList) => {
	      return Promise.all(keyList.map((key) => {
	        if (key !== CACHE_NAME) {
	          console.log('[ServiceWorker] Removing old cache', key);
	          return caches.delete(key);
	        }
	      }));
	    })
	);
});

//checks for a valid current session id - updates it if not, rejects if new session is invalid
function verifySessionUser () {
	console.log('SW - verifying session user');
	return new Promise((resolve, reject) => {
		//attempt to get the current session user
		getSessionUser()
			//success - the session id is valid and up to date
			.then(userId => resolve(userId))
			//error - getting it failed, we should update it
			.catch(currentSessionStatus => {
				console.log('SW - session invalid: '+currentSessionStatus);
				updateSessionUser()
					.then((freshSessionUserId) => resolve(freshSessionUserId))
					.catch(err => reject(err));
			});
	});
}

//tries to get the currently stored session user; rejects if it's expired or empty
function getSessionUser () {
	console.log('SW - reading stored session user');
	return new Promise((resolve, reject) => {

		//check if the session has expired
		idbKeyval.get('lastUserSessionUpdate').then(lastUpdate=>{
			if (!lastUpdate)
				var minutesSinceLastUpdate;
			else
				var minutesSinceLastUpdate = Math.floor((new Date() - lastUpdate) / 1000 / 60);
			//console.log('minutes',minutesSinceLastUpdate,(new Date() - lastUpdate),USER_SESSION_EXPIRATION,minutesSinceLastUpdate > USER_SESSION_EXPIRATION);

			//check if session has expired
			if (minutesSinceLastUpdate >= USER_SESSION_EXPIRATION) {
				console.log('session has expired',minutesSinceLastUpdate ,'>=', USER_SESSION_EXPIRATION,minutesSinceLastUpdate >= USER_SESSION_EXPIRATION);
				return reject('expired');
			}

			//get currently stored session id
			idbKeyval.get('currentUserSession').then(sessionUserId => {
				if (!sessionUserId) return reject('empty');

				//success
				return resolve(sessionUserId);
			});

		});
	});
}

function updateSessionUser () {
	console.log('SW - updating session user');
	return new Promise((resolve, reject) => {
		//fetch session user id from server
		fetch('/user/session').then((e) => {

			//the request failed, most liked returned 404 because the user isn't logged in, so delete the saved session info if we have it
			if (!e.ok) {
				console.log('SW - session request failed',e);
				idbKeyval.del('currentUserSession');
				return reject('request failed');
			}

			//get text value of page (wow we need a whole function to do this? idiots.)
			e.text().then(text => {
				if (text.length != 24) {
					console.log('SW - invalid session id returned',text,text.length);
					idbKeyval.del('currentUserSession');
					return reject('invalid length');
				}

				//success - save value to local storage
				idbKeyval.set('currentUserSession',text);
				idbKeyval.set('lastUserSessionUpdate',new Date());
				console.log('SW - updated session',text);
				return resolve(text);
			});
		});
	});
}

/*global fetch, evt, caches, self, BroadcastChannel*/